<article id="cuentas-fondos" class="container">
  <div class="row">
    <div class="col-md-12">
      <app-title-with-back>Instrucciones de Consignación de Fondos</app-title-with-back>
      <h5 uni-heading alignText="center" class="mb-1">
        <p>Cuentas para depósitos por tipos de fondos de inversión</p>
        <a href="assets/files/cuentas-depositos.pdf" download>Descargar PDF</a>
      </h5>
    </div>

    <div class="col-md-12">
      <div class="fondo-container" *ngFor="let fondo of fondosInversion">
        <div class="row">
          <div class="col-lg-3 m-auto-0">
            <h5 uni-heading>{{ fondo.fondo.nombre }}</h5>
            <h5 uni-heading>
              RNC: <span class="text-info">{{ fondo.fondo.rnc }}</span>
            </h5>
          </div>
          <div class="col-lg-9">
            <div class="row">
              <div class="col-md-12"></div>
              <div class="col-md-6 col-lg-4" *ngFor="let cuenta of fondo.cuentas">
                <div
                  class="shadow-box p-4 mb-4 dark-tooltip"
                  popover="Número de cuenta copiado"
                  triggers=""
                  [outsideClick]="true"
                  [isOpen]="cuenta.popover"
                >
                  <img [src]="cuenta.logo" alt="cuenta.banco" class="img-fluid" />
                  <div class="tipo-cuenta pt-4">
                    <div>
                      <small>Tipo de Cuenta:</small>
                    </div>
                    <span>{{ cuenta.tipo }}</span>
                  </div>
                  <div class="numero-cuenta pt-4">
                    <small>No. de Cuenta:</small>
                    <br />
                    <span>{{ cuenta.numero }}</span>

                    <div class="text-right">
                      <button uni-icon-button variant="info" (click)="copyCuenta(cuenta)">
                        <uni-icon name="copy"></uni-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="text-center info-tag no-icon px-5">
        Una vez transferidos los fondos debe remitir a su ejecutivo de negocios de AFI Universal y a la siguiente dirección
        <a href="mailto: inversionesafi@universal.com.do">inversionesafi@universal.com.do</a> el comprobante de transacción para
        fines de registro.
      </div>
    </div>
  </div>
</article>
